export const trustSectionContent = {
  en: {
    title: "Real Results, From Home",
    description: ` Revimo helps people reduce pain and move with confidence
        using step‑by‑step video programs designed by licensed
        physiotherapists.`,
    block1Text: "of users report less pain after 4 weeks of consistent use.",
    block2Title: "“My knee finally feels stable again.”",
    block2Text: `“The videos were easy to follow and I could do everything at
                home between shifts.” – Anna, 34`,
    block3Title: "“Perfect for busy schedules.”",
    block3Text: `“I did the exercises in my living room after work and still saw
                results in a few weeks.” – Mark, 41`,
    warning: "Revimo does not guarantee specific results, because outcomes vary by individual condition, consistency, technique, and other factors outside your control.",
  },
  sl: {
    title: "Resnični rezultati kar od doma",
    description: ` Revimo pomaga zmanjšati bolečino in izboljšati gibanje
        z vodenimi video programi, ki jih pripravijo licencirani
        fizioterapevti.`,
    block1Text: "uporabnikov poroča o manj bolečinah po 4 tednih redne uporabe.",
    block2Title: "“Koleno je končno spet stabilno.”",
    block2Text: `“Videi so bili enostavni za sledenje in vse vaje sem lahko
                opravljala doma med izmenami.” – Ana, 34`,
    block3Title: "“Odlično za zaseden vsakdan.”",
    block3Text: `“Vaje sem delal v dnevni sobi po službi in že v nekaj tednih
                opazil napredek.” – Marko, 41`,
    warning: "Revimo ne jamči specifičnih rezultatov, ker se izidi razlikujejo glede na posameznikovo predhodno stanje, doslednost in druge dejavnike, na katere nimate vpliva.",
  },
} as const;
